import { ProductImportStatus } from "../../../../entities-generated/common/product-import-status";
import { ILowesStormDoorHandleListing } from "../../../../entities-generated/models/lowes-storm-door-handle/lowes-storm-door-handle-listing";
import { BwjListing } from "../../../../framework/components/bwj-listing";

interface ILowesStormHandleListItemProps {
  listing: ILowesStormDoorHandleListing;
  onClick: (listing: ILowesStormDoorHandleListing) => void;
}

export const LowesStormHandleListItem: React.FunctionComponent<ILowesStormHandleListItemProps> = (props) => {
  const { listing } = props;

  return (
    <BwjListing
      heading={listing.name}
      secondaryLine={ProductImportStatus[listing.importStatus]}
      data={listing}
      onClick={props.onClick}
    />
  );
};